// extracted by mini-css-extract-plugin
export default {"container":"Section_container__jih+c","content":"Section_content__h4u6q"};